import { makeStubAdapter } from './_stub';
export const gamedistributionAdapter = makeStubAdapter('gamedistribution');
